import styled, {css} from "styled-components";
import {VideoSlideFilterButtonDefaultBox} from "./video-slide-filter-button.default.box";


export const VideoSlideFilterButtonMrGreenBox = styled(VideoSlideFilterButtonDefaultBox)`
  color: ${props => props.theme.colors.videoSlidesFilterButtonOutline ? props.theme.colors.videoSlidesFilterButtonOutline : props.theme.colors.backgroundLight};
  border-color: ${props => props.theme.colors.videoSlidesFilterButtonOutline ? props.theme.colors.videoSlidesFilterButtonOutline : props.theme.colors.backgroundLight};

  ${props => props.isActive ? css`
    font-weight: 600;
    border-color: ${props => props.theme.colors.brandPrimary};
    color: ${props => props.theme.colors.brandPrimary};
    background-color: ${props => `${props.theme.colors.brandPrimary}30`}; // 30 is the opacity
  ` : null}
`